module.exports = __webpack_public_path__ + "static/media/calendar-edit.6f008685.svg";